import React, {useEffect, useState} from 'react';
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import {CARD} from "./Card";

export const COLLAPSIBLE_CARD = {
    ALIGNED: {
        LEFT: 'left',
        RIGHT: 'right'
    }
}

/**
 * @param {{
 *   title: string,
 *   aligned?: 'left' | 'right',
 *   initExpanded?: boolean,
 *   parentExpand?: boolean | null,
 *   variant?: 'outlined',
 *   padding?: string,
 *   boxRadius?: string,
 *   rounded?: boolean,
 *   className?: string,
 *   children?: React.ReactNode,
 * }} props
 */
const CollapsibleCard = (props) => {
    const {
        aligned = COLLAPSIBLE_CARD.ALIGNED.RIGHT,
        initExpanded = false,
        parentExpand = null,
        title,
        boxRadius = CARD.RADIUS.SMALL,
        rounded = true,
        padding = CARD.PADDING.MEDIUM,
        className,
        variant,
        children,
        ...other
    } = props;

    const [expanded, setExpanded] = useState(initExpanded);

    const classes = ['ch-card', className, rounded && 'rounded', variant === 'outlined' && 'ch-card--outlined', padding, boxRadius]
        .filter(Boolean).join(' ');

    useEffect(() => {
        if (parentExpand !== null) setExpanded(parentExpand);
    }, [parentExpand]);

    const icon = expanded
        ? <ExpandLess style={{width: 24, height: 24}}/>
        : <ExpandMore style={{width: 24, height: 24}}/>;

    const isLeft = aligned === 'left';

    return (
        <div className={classes} {...other}>
            <div
                className='ch-card-expandable'
                style={isLeft ? undefined : {justifyContent: 'space-between'}}
                onClick={() => setExpanded(e => !e)}>
                {isLeft ? icon : <h4>{title}</h4>}
                {isLeft ? <h4>{title}</h4> : icon}
            </div>
            {expanded && (
                isLeft
                    ? <div className="margin-l--l">{children}</div>
                    : children
            )}
        </div>
    );
}

export default CollapsibleCard;
